import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Unlock: React.FunctionComponent<Props> = (props) => {
  const { size = 22, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.99902 1.45801C10.464 1.45805 10.9249 1.5496 11.3545 1.72754C11.784 1.90549 12.1742 2.16641 12.5029 2.49512C12.8318 2.82399 13.0925 3.21484 13.2705 3.64453C13.4485 4.07421 13.54 4.53493 13.54 5V7.29102H14.999C15.2752 7.2911 15.5401 7.40141 15.7354 7.59668C15.9306 7.79201 16.04 8.05682 16.04 8.33301V16.666C16.04 16.9423 15.9307 17.208 15.7354 17.4033C15.5401 17.5985 15.2751 17.7079 14.999 17.708H4.99902C4.72276 17.708 4.45707 17.5987 4.26172 17.4033C4.06637 17.208 3.95703 16.9423 3.95703 16.666V8.33301C3.95703 8.05689 4.06657 7.792 4.26172 7.59668C4.45707 7.40133 4.72276 7.29102 4.99902 7.29102H13.124V5C13.124 4.1712 12.7941 3.37609 12.208 2.79004C11.622 2.20417 10.8276 1.87509 9.99902 1.875C9.17022 1.875 8.37511 2.20399 7.78906 2.79004C7.35253 3.22657 7.05912 3.77903 6.9375 4.375H6.51367C6.64043 3.66782 6.97913 3.01012 7.49414 2.49512C8.15833 1.83093 9.05972 1.45801 9.99902 1.45801ZM4.37402 17.291H15.624V7.70801H4.37402V17.291ZM9.99902 11.458C10.2751 11.4581 10.5401 11.5675 10.7354 11.7627C10.9307 11.958 11.04 12.2237 11.04 12.5C11.04 12.7761 10.9306 13.0411 10.7354 13.2363C10.5401 13.4316 10.2752 13.5409 9.99902 13.541C9.72276 13.541 9.45707 13.4317 9.26172 13.2363C9.06655 13.0411 8.95712 12.7761 8.95703 12.5C8.95703 12.2237 9.06637 11.958 9.26172 11.7627C9.45707 11.5673 9.72276 11.458 9.99902 11.458Z'
        fill='#101828'
        stroke='white'
        strokeWidth='1.25'
      />
    </svg>
  );
};

export default Unlock;
